/* eslint-disable max-classes-per-file */
import React, { Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { Config } from '../config';

const Context = React.createContext();

const LanguageConsumer = Context.Consumer;

let languageFile = Config.language.defaultFile;

class LanguageProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: Config.language.default,
    };
    this.onChangeLanguage = this.onChangeLanguage.bind(this);
  }

  componentDidMount() {
    const { language } = this.state;
    this.setLanguage(localStorage.getItem('language') || language);
  }

  onChangeLanguage(language) {
    this.setLanguage(language);
  }

  setLanguage(language) {
    this.setState({ language });
    localStorage.setItem('language', language);

    try {
      // eslint-disable-next-line global-require, import/no-dynamic-require
      languageFile = require(`../assets/lang/${language}`);
    } catch (e) {
      languageFile = Config.language.defaultFile;
    }
  }

  render() {
    const { language } = this.state;
    const { children } = this.props;
    return (
      <Context.Provider value={{
        language,
        onChangeLanguage: this.onChangeLanguage,
      }}
      >
        {children}
      </Context.Provider>
    );
  }
}

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const SetLanguageFile = text => {
  const languageFileLocal = (JSON.parse(localStorage.getItem('languageFile')) || {});
  languageFileLocal[text] = text;

  try {
    localStorage.setItem('languageFile', JSON.stringify(languageFileLocal));
    // eslint-disable-next-line no-empty
  } catch (error) { }
  return text;
};

const Translate = text => (ReactHtmlParser(languageFile[text] || SetLanguageFile(text)));

const TranslateExt = text => (
  <LanguageConsumer>
    {() => (Translate(text))}
  </LanguageConsumer>
);

class LanguageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownLanguage: false,
    };
  }

  toggleLanguage() {
    this.setState(prevState => ({
      dropdownLanguage: !prevState.dropdownLanguage,
    }));
  }

  render() {
    const { dropdownLanguage } = this.state;
    return (
      <LanguageConsumer>
        {({ language, onChangeLanguage }) => {
          const active = Config.language.list.filter(item => item.key === language).map(item => (
            <Fragment key={item.key}>
              <img src={`/assets/images/flags/${item.icon}`} className="mr-2" height="16" alt="" />
              {item.text}
              <span className="mdi mdi-chevron-down ml-2" />
            </Fragment>
          ));

          const list = Config.language.list.map(item => (
            <button type="button" key={item.key} className={`dropdown-item ${(language === item.key ? 'active' : '')}`} onClick={() => { onChangeLanguage(item.key); this.toggleLanguage(); }}>
              <img src={`/assets/images/flags/${item.icon}`} alt="" height="24" />
              <span className="ml-1 mr-1">{item.text}</span>
            </button>
          ));

          return (
            <Dropdown isOpen={dropdownLanguage} toggle={() => this.toggleLanguage()}>
              <DropdownToggle className="nav-link nav-link-login dropdown-toggle arrow-none testflag waves-effect" caret tag="a">
                {active}
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu dropdown-menu-right language-switch">
                {list}
              </DropdownMenu>
            </Dropdown>
          );
        }}
      </LanguageConsumer>
    );
  }
}

export { LanguageConsumer, LanguageProvider, Translate, TranslateExt, LanguageList };
